import { styled, Theme } from "@mui/material/styles";
import { TimeField } from "@mui/x-date-pickers/TimeField";

import colors from "../../assets/theme/base/colors";
import borders from "../../assets/theme/base/borders";
import typography from "../../assets/theme/base/typography";


const { size } = typography;
const { borderWidth } = borders;
const { info, inputBorderColor, dark } = colors;

export default styled(TimeField)(({ theme, ownerState }: { theme?: Theme; ownerState: any }) => {
    const { palette, functions } = theme;
    const { error, success, disabled } = ownerState;

    const { transparent, error: colorError, success: colorSuccess } = palette;
    const { pxToRem } = functions;

    const errorStyles = () => ({
        "& .MuiIconButton-root": {
            color: colorError.main,
        },
        "& .MuiOutlinedInput-notchedOutline, &:after": {
            borderColor: colorError.main,
        },

        "& .Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline, &:after": {
                borderColor: colorError.main,
            },
        },

        "& .MuiInputLabel-root": {
            color: colorError.main,
            transform: `translate(0, -1.5px) scale(0.75)`,
            "& .Mui-focused": {
                color: colorError.main,
            },
        },

        "& .MuiInputBase-root:before": {
            borderColor: colorError.main,
        },

        "& .MuiFormHelperText-root": {
            color: colorError.main,
            marginLeft: 0,
            marginRight: 0,
        },
    });

    const successStyles = () => ({
        "& .MuiIconButton-root": {
            color: colorSuccess.main,
        },
        "& .MuiOutlinedInput-notchedOutline, &:after": {
            borderColor: colorSuccess.main,
        },

        "& .Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline, &:after": {
                borderColor: colorSuccess.main,
            },
        },

        "& .MuiInputLabel-root.Mui-focused": {
            color: colorSuccess.main,
            transform: `translate(0, -1.5px) scale(0.75)`,
        },
    });

    const disabledStyles = () => ({
        "& .MuiIconButton-root": {
            color: "#dddddd",
        },
        "& .MuiInputBase-input": {
            color: "#dddddd",
        },
    });

    const rootStyles = () => ({
        "& .MuiOutlinedInput-input": {
            padding: `4px 0 5px`,
            marginTop: pxToRem(16),
        },
        "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginRight: 0,
        },
        "& .MuiOutlinedInput-notchedOutline": {
            fontSize: size.sm,
            color: dark.main,
            border: `none`,
            borderBottom: `${borderWidth[1]} solid ${inputBorderColor}`,
            borderRadius: 0,
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: `${borderWidth[1]} solid ${inputBorderColor}`,
            },

            "&:before": {
                borderColor: inputBorderColor,
            },

            "&:after": {
                borderColor: info.main,
            },
        },
        "& .MuiInputLabel-root": {
            transform: `translate(0, -1.5px) scale(0.75)`,
        },
    });

    return {
        backgroundColor: transparent.main,
        pointerEvents: disabled ? "none" : "auto",
        ...rootStyles(),
        ...(error && errorStyles()),
        ...(success && successStyles()),
        ...(disabled && disabledStyles()),
    };
});
